import { z } from "zod";

import {
  ADMINISTRATION_FORM,
  Category,
  Price,
  Subscription,
} from "@/shared/domains";
import { DISABLED_REASON } from "./constants";

const metadataSchema = z.object({
  message: z.string(),
});

const alreadyHasSubscriptionSchema = z.object({
  type: z.literal(DISABLED_REASON.ALREADY_HAS_SUBSCRIPTION),
  metadata: metadataSchema.extend({
    subscriptionId: Subscription.shape.id.nullable(),
  }),
});

const genericDisabledReasonSchema = z.object({
  type: z.enum(DISABLED_REASON).exclude(["ALREADY_HAS_SUBSCRIPTION"]),
  metadata: metadataSchema.nullable(),
});

export const disabledReasonSchema = z.discriminatedUnion("type", [
  alreadyHasSubscriptionSchema,
  genericDisabledReasonSchema,
]);

export const productSchema = z.object({
  id: z.number(),
  name: z.string(),
  description: z.string().optional(),
  features: z.string(),
  disclaimer: z.string(),
  thumbnail: z.url().nullable(),
  category: Category.pick({ id: true, name: true, slug: true }),
  prices: z.array(Price),
  slug: z.string(),
  tags: Price.shape.tags,
  priceTag: z.string().nullish(),
  disabled: z.array(disabledReasonSchema).nullish(),
  commonDisqualifiers: z.string().nullish(),
  administrationForm: z.enum(ADMINISTRATION_FORM),
  retailPrice: z.number().nullish(),
});

export const productGroupSchema = z.object({
  id: z.number(),
  name: z.string(),
  products: productSchema.array(),
});

export const categoryWithProductsSchema = Category.omit({
  treatments: true,
}).extend({
  products: z.array(productSchema),
});

const itemSchema = z.object({
  label: z.string(),
  amount: z.string(),
});

export const summarySchema = z.object({
  subtotal: z.string(),
  items: z.array(itemSchema),
  total: z.string(),
});
